import { CheckCircleIcon } from '@heroicons/react/20/solid';

export interface SuccessAlertProps {
  text: string;
}

export const SuccessAlert = (props: SuccessAlertProps) => {
  return (
    <div className="rounded-md bg-green-50 p-4">
      <div className="flex">
        <div className="shrink-0">
          <CheckCircleIcon aria-hidden="true" className="size-5 text-green-400" />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-sm text-green-800">{props.text}</p>
        </div>
      </div>
    </div>
  );
};
